import styled, { css } from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

const baseCapsuleStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  user-select: none;
`

export const StyledCapsule = styled.button<{
  active: boolean
}>`
  ${baseCapsuleStyles}
  height: 32px;
  font-weight: 700;
  padding: ${({ active }) => (active ? `0px 12px` : `0px 2px`)};
  margin: 0px 12px 0px 0px;
  color: ${({ active, theme }) =>
    active ? theme.colors.brandDark : theme.colors.brand};
  background: ${({ active, theme }) =>
    active ? theme.colors.brandLight : 'transparent'};
  font-size: 14px;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
    height: 36px;
  }

  ${({ active, theme }) =>
    !active &&
    css`
      &:hover {
        color: ${theme.colors.brandLight};
      }
    `}
`

export const CapsuleContainer = styled.div`
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  align-items: center;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Add scrollable padding on left and right */
  &::before,
  &::after {
    content: '';
    flex-shrink: 0;
  }

  &::before {
    width: 12px;
  }

  &::after {
    width: 12px;
  }

  @media (min-width: ${breakpoints.tablet}px) {
    &::before {
      width: 24px;
    }

    &::after {
      width: 24px;
    }
  }
`
